<template>
  <div
    class="aha-avatar"
    :class="[`aha-avatar--${size}`]"
    :style="{width: `${width}px`, height: `${height}px`}"
  >
    <div v-if="image" class="aha-avatar__image">
      <img :src="image">
    </div>
    <div v-else class="aha-avatar__image" :style="{backgroundColor: avatarColor}">
      {{ showingName | textAvatar }}
    </div>
  </div>
</template>

<script>
import colorUtil from '../../utils/colors'

export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'Unknown',
    },
    id: {
      type: Number,
      default: null,
    },
  },

  computed: {
    showingName() {
      return this.name || 'Unknown'
    },
    avatarColor() {
      const id = this.id ? this.id : this.showingName.charCodeAt(0)
      return colorUtil.getRandomColor(id)
    },
  },

}
</script>

<style lang="scss" scoped>
.aha-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
}
.aha-avatar--sm {
  width: 20px;
  height: 20px;
}
.aha-avatar--md {
  width: 28px;
  height: 28px;
}
.aha-avatar--lg {
  width: 36px;
  height: 36px;
}
.aha-avatar--xl {
  width: 42px;
  height: 42px;
}

.aha-avatar__image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
  text-transform: uppercase;
  border-radius: 100%;
  img {
    border-radius: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>>
